/**
 * minute2sec wordmark — "minute" + bold teal "2" + "sec".
 *
 * Default color inherits from `color` (so dark surfaces work without any prop).
 * The teal "2" character is the only colored glyph, drawn from `--brand-teal`.
 */

import type { CSSProperties } from "react";

type Props = {
  size?: number;          // font-size in px
  /** Override the "2" color (defaults to var(--brand-teal)). */
  accent?: string;
  /** Use light text (white) — for dark/brand backgrounds. */
  onDark?: boolean;
  style?: CSSProperties;
};

export function LogoWordmark({ size = 16, accent, onDark, style }: Props) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        fontFamily: "var(--font-sans)",
        fontSize: size,
        fontWeight: 600,
        letterSpacing: "-0.02em",
        color: onDark ? "#fafaf9" : "var(--ink)",
        ...style,
      }}
      aria-label="minute2sec"
    >
      <span>minute</span>
      <span
        style={{
          color: accent ?? "var(--brand-teal)",
          fontWeight: 700,
        }}
      >
        2
      </span>
      <span>sec</span>
    </span>
  );
}
